import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { AttendanceService } from 'src/app/service/attendance.service';
import { ScoresService } from 'src/app/service/scores.service';

declare var $: any;
@Component({
  selector: 'app-student-eligiblity',
  templateUrl: './student-eligiblity.component.html',
  styleUrls: ['./student-eligiblity.component.scss']
})
export class StudentEligiblityComponent implements OnInit {

  select: any;
  showLoader: boolean = false;
  repeaterPage: boolean = false;
  generatingReport: boolean = false;
  searchByFields: any;
  students: any = [];
  table: any;
  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;
  newStudentStatus: any = 'present';

  ScheduleHeader: any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStudent: any;
  currentGroup: any;
  currentDate: any;
  currentLang: any;

  excelHeaderName: any;

  statistics:any=[];

  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;

  groups: any = [];
  allstudents: any = [];

  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    group: new FormControl('', [
      // Validators.required,
    ]),
    student: new FormControl('', [
      // Validators.required,
    ]),
  });

  constructor(private scoresService: ScoresService,private attendance: AttendanceService, private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService) { }

  ngOnInit(): void {
   
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;
    this.currentLang = this.globals.lang;

    this.getYears();
    this.initMultiSelectDropdown();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      //this.initFormDropDownsFields();
    });
  }

  updateTable() {
    if (this.table) {
      this.table.destroy();
    }
    //  else { $("#datatable").DataTable().destroy(); }

    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        // columnDefs: [{
        //   orderable: false,
        //   className: 'select-checkbox',
        //   targets: 0
        // }],
        // select: {
        //   style: 'multi',
        //   selector: 'td:first-child',
        //   blurable: false
        // },
        // select: true,
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: false,
        ordering: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'excelHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'EXCEL',
          exportOptions: {
            columns: ':not(.notExport)'
          },
          className: 'datatable_custom_buttons',
        }],
      }).on('select.dt deselect.dt', (e: any) => {
        let numberOfRecords = this.table.rows().nodes().length;
        let selectedRows = this.table.rows(".selected").nodes().length;

        if (numberOfRecords === selectedRows)
          $(".select-all").prop("checked", true);
        else
          $(".select-all").prop("checked", false);

        this.table.button(0).enable(selectedRows > 0);
        this.table.button(1).enable(selectedRows === 1);
        this.table.button(2).enable(selectedRows === 1);
      });;

      $('#datatable').on('click', '.select-all', (e: any) => {
        if (e.target.checked)
          this.table.rows().select();
        else
          this.table.rows().deselect();
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if (dataTableButtonsDiv != null) {
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }

      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);

  }

  searchFormChange() {
  }

  searchFormSubmit() {
    if (this.searchForm.valid) {
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      this.currentGroup = this.searchForm.controls.group.value.length > 0 ? this.searchForm.controls.group.value : 0;
      this.currentStudent = this.searchForm.controls.student.value.length > 0 ? this.searchForm.controls.student.value : 0;
      // this.currentDate = this.searchForm.controls.date.value;
      this.preViewAction();
      // console.log("Searching form");
      // console.log(this.searchForm.controls.student.value.length);
      // console.log(this.searchForm.value);
    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find(key => object[key] === value);
  }

  getScoresStudentEligibilityStatistic(){
    this.scoresService.getScoresStudentEligibilityStatistic(this.username).subscribe(
      data => {

        this.statistics=[{
          name:"Eligible",
          value:data[0].eligibale
        },{
          name:"Non-Eligible Ongoing",
          value:data[0].nonEligibileOngoing
        },{
          name:"Non-Eligible Clinical",
          value:data[0].nonEligibileClinical
        },
        {
          name:"Total",
          value:data[0].total
        }]
      },
      error => {
        //this.showLoader = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_GET_REPORT'));
      });
  }
  preViewAction() {
    this.generatingReport = true;
    if (this.table) {
      this.table.destroy();
    }
    this.scoresService.generatestudentEligibilitReport(this.orgId, this.currentYear, this.currentSemester, this.currentGroup, this.currentStudent, this.currentLang, this.username, this.currentBatch).subscribe(
      data => {
        this.scoresService.getstudentEligibilitReport(this.username).subscribe(
          data => {
            // console.log("intial data");
            // console.log(data);
            if (data.length > 0) {
              data.shift();
              if (data[1]) {
                var indexString = this.getKeyByValue(data[1], "<LAST COLUMN>")?.replace("col", "");
                let maxColumn = 0;
                if (indexString) {
                  maxColumn = parseInt(indexString);
                }

                let newData = data.map((element: any) => {
                  let row: any = {};
                  row.rowdesc = element.rowdesc;
                  for (let i = 1; i < maxColumn; i++) {
                    let indexName = 'col';
                    if (i <= 9) {
                      indexName += "0" + i;
                      // row['col0'+i] =
                    } else {
                      indexName += i;
                      // row['col'+i] =
                    }
                    row[indexName] = element[indexName];

                  }
                  return row;
                });
                //header
                this.ScheduleHeader = newData[0];
                this.ScheduleHeader = Object.values(this.ScheduleHeader);
                //data
                this.students = newData.map((element: any) => {
                  return Object.values(element);
                });
                this.students.shift();
                this.getScoresStudentEligibilityStatistic();
                this.updateTable();
                this.generatingReport = false;
                // console.log(this.ScheduleData);
                // this.generateBatchStatisticsReportExcel(newData);
              } else {
                this.toastrService.warning(this.translate.instant('NO_DATA_FOUND'));
              }

            } else {
              this.toastrService.error(this.translate.instant('NOT_FOUND'));
            }

          },
          error => {
            //this.showLoader = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_GET_REPORT'));
          }
        );
      },
      error => {
        //this.showLoader = false;
        this.toastrService.error(this.translate.instant('FAIL_TO_GET_REPORT'));
      }
    );

  }

  test() {
    console.log(this.table.rows({ selected: true }).data().toArray());
    // let currentDatatableRows = this.table.rows({ select: 'current' }).data().toArray();
    //.rows({ select: 'current' }).data().toArray()
  }

  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  getBatchGroups() {
    this.searchForm.controls.group.setValue('');
    this.searchForm.controls.student.setValue('');
    let batch = this.searchForm.controls.batch.value;
    if (batch) {
      this.attendance.getBatchGroups(this.orgId, batch)
        .subscribe(
          data => {
            this.groups = data;
            this.getStudentsByGroup();
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.group.reset();
      this.groups = [];
    }
  }

  getStudentsByGroup() {
    this.searchForm.controls.student.setValue('');
    let groupid = this.searchForm.controls.group.value > 0 ? this.searchForm.controls.group.value : 0;
    let yearid = this.searchForm.controls.year.value;
    let semesterid = this.searchForm.controls.semester.value;
    if (yearid && semesterid) {
      this.attendance.getStudentsByGroup(this.orgId, yearid, semesterid, groupid)
        .subscribe(
          data => {
            this.allstudents = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.student.reset();
      this.allstudents = [];
    }
  }

  getBase64(event: any, index: number) {
    let img = event.target;
    let dataURL: any;
    var canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    // canvas.height = img.height;
    // canvas.width = img.width;

    // canvas.height = img.clientHeight;
    // canvas.width = img.clientWidth;

    canvas.height = img.naturalHeight;
    canvas.width = img.naturalWidth;
    // let newWidth = 100;
    // let newHeight = 100;
    ctx.drawImage(img, 0, 0);
    // ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL('image/jpeg');
    this.students[index].imageBase64 = dataURL;
    // console.log("test func: ");
    // console.log(dataURL);
    // console.log("data: ");
    // console.log(this.data);
  }

  updateStudentStatus() {
    console.log("update student status");
    console.log("New status: " + this.newStudentStatus);
    console.log("Selected Students: ");
    let selectedStudents = this.table.rows({ selected: true }).data().toArray();
    console.log(selectedStudents);
  }

  // Excel sheet
  async generateExcel() {

    let exportIndexes: any;
    let exportIndexesOrderByHeader: any = [];
    // Image propability excel columns
    const imagePropabilityExcelColumns = ['A', 'B', 'C', 'D', 'E'];
    // Excel Title, Header, Data
    const title = 'Yearly Social Sharing Education For Betterment';
    let header = this.excelHeaderName;
    if (exportIndexes?.length > 0) {
      header = this.excelHeaderName.filter((el: any, index: any) => {
        if (exportIndexes.includes(index + 1)) {
          exportIndexesOrderByHeader.push(index + 1);
        }
        return exportIndexes.includes(index + 1);
      });
    }

    // const data = this.candidateInquiriesData;
    // const data = this.getFilterData();
    const data = this.students;

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Inquiry sheet');

    // Add Row and formatting
    // const titleRow = worksheet.addRow([title]);
    // titleRow.font = {
    //   name: 'Corbel',
    //   family: 4,
    //   size: 16,
    //   underline: 'double',
    //   bold: true
    // };

    // worksheet.addRow([]);
    // const subTitleRow = worksheet.addRow(['Date : 06-09-2020']);

    // worksheet.mergeCells('A1:D2');

    // Blank Row
    // worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        // bgColor: { argb: 'FF0000FF' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    // const imageId1 = workbook.addImage({
    //   filename:
    //     'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   extension: 'jpeg'
    // });
    //worksheet.addImage(imageId1, 'G6:H8');
    // Add Data and Conditional Formatting
    let imageOptionIndexAtDropdown = 6;
    let imageColumnName = '';

    data.forEach((d: any) => {
      let imageBase64 = d.imageBase64;
      let imageId1 = workbook.addImage({
        // buffer: fs.readFileSync(
        //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
        // ),
        base64: imageBase64,
        extension: 'png'
      });
      // worksheet.addImage(imageId1, 'G20:H22');
      // d[6] = imageId1;
      // worksheet.addImage(imageId1, 'G20:H22');
      let rowData = [
        "",
        d.fullNameAr,
        d.fullNameEn,
        (d.gender == "M") ? this.translate.instant("MALE") : this.translate.instant("FEMALE"),
        d.status,
      ]

      if (exportIndexes?.length > 0) {
        rowData = rowData.filter((el: any, index: any) => {
          return exportIndexes.includes(index + 1);
        });

        const row = worksheet.addRow(rowData);
        row.height = 100;

        if (exportIndexes.includes(imageOptionIndexAtDropdown)) {
          let imageIndex = exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown);
          worksheet.addImage(imageId1, imagePropabilityExcelColumns[imageIndex] + (2 + imageId1) + ':' + imagePropabilityExcelColumns[imageIndex] + (2 + imageId1));
        }
      } else {
        const row = worksheet.addRow(rowData);
        row.height = 100;
        worksheet.addImage(imageId1, 'A' + (2 + imageId1) + ':A' + (2 + imageId1));
      }
      // let qty: any;
      // qty = row.getCell(5);
      // as Cell | undefined
      // let color = 'FF99FF99';
      // if (+qty.value < 500) {
      //   color = 'FF9999';
      // }

      // qty.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
    });

    // worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 30;
    if (exportIndexes?.length > 0 && exportIndexes.includes(imageOptionIndexAtDropdown)) {
      worksheet.getColumn(exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown) + 1).width = 20;
    } else {
      worksheet.getColumn(6).width = 20;
    }
    // worksheet.addRow([]);

    //     let workbook2 = Excel.stream.xlsx.WorkbookWriter()
    // workbook2.media.push({
    //     filename: './Picture1.png',
    //     extension: 'png',
    //   })
    // worksheet.addImage(0, 'B1:E6')

    // Ali
    // const logoBase64 =
    //   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAFKCAMAAADcyF29AAABxVBMVEVHcEwJCAggFxEBAQE2KyQAAAA0LScAAAAAAAA1LysXEQ0EBAQFBAMDAwMLCQgGBQUFBAOEQhUHBwZjQSuScFoVFRZvNAx5NghcOyaudU8yMDBrNhOiViMZFhXEdD3Ef0+4ZzFISUdSJwliMA6BPA6lVR8CAgEDAgQPDhANDgsKCQoVFhPObi4SERS2VxcE.......';
    //
    // const readFileInNode = (filename) => {
    //   console.log('readFileInNode - fs', fs)
    //   console.log('readFileInNode - fsMod', fsMod)
    //   return new Promise((resolve, reject) => fs.readFile(filename, 'utf8', (err, data) => err ? reject(err) : resolve(data)))
    // }
    //Test base 64 image 
    // let image = document.createElement('img');
    // image.width = 10;
    // image.height = 10;
    // image.src = "https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png";
    //end
    // console.log(this.myImage.nativeElement);
    // add image to workbook by buffer
    // const imageId1 = workbook.addImage({
    //   // buffer: fs.readFileSync(
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
    //   // ),
    //   base64: this.getDataUrl(this.myImage.nativeElement),
    //   extension: 'png'
    // });

    // const imageId1 = workbook.addImage({
    //   // filename:
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   base64: logoBase64,
    //   extension: 'png'
    // });
    // worksheet.addImage(imageId1, 'G20:H22');
    // Footer Row
    // const footerRow = worksheet.addRow([
    //   'This is system generated excel sheet.'
    // ]);
    // footerRow.getCell(1).fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FFCCFFE5' }
    // };
    // footerRow.getCell(1).border = {
    //   top: { style: 'thin' },
    //   left: { style: 'thin' },
    //   bottom: { style: 'thin' },
    //   right: { style: 'thin' }
    // };

    // Merge Cells
    // worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      fs.saveAs(blob, 'Inquiry.xlsx');
    });
  }

  initMultiSelectDropdown() {
    // Multi select dropdown
    this.excelHeaderName = [
      this.translate.instant("STUDENT_PHOTO"),
      this.translate.instant("FULL_NAME_ENGLISH"),
      this.translate.instant("FULL_NAME_ARABIC"),
      this.translate.instant("GENDER"),
      this.translate.instant("STATUS")
    ];
  }

  isNumber(str: string): boolean {
    if (typeof str !== 'string') {
      return false;
    }

    if (str.trim() === '') {
      return false;
    }

    return !Number.isNaN(Number(str));
  }
}

